import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { SharedConfirmationDialogComponent } from '@app/shared/component/shared-confirmation-dialog/shared-confirmation-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { ButtonSlideComponent } from '@app/shared/component/button-slide/button-slide.component';
import { AutoUnsubscribe } from '@app/shared/decorators/auto-unsubscribe.decorator';
import { CommonModule } from '@angular/common';
@AutoUnsubscribe()
@Component({
    selector: 'discovery-configuration-status',
    templateUrl: './discovery-configuration-status.component.html',
    styleUrl: './discovery-configuration-status.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports:[
      CommonModule,
      ButtonSlideComponent
    ]
})
export class DiscoveryConfigurationStatusComponent implements OnInit, OnDestroy {
  @ViewChild(ButtonSlideComponent) buttonSlide!: ButtonSlideComponent;
  @Input() menus: any = [];
  @Input() discoveryCategoryConfigType: any = {};
  @Input() isOwnerRegisterDataType: boolean = false;
  @Output() setFinalStepValue = new EventEmitter();
  unsavedTemplates: any = [];
  emptyTemplate: any = [];
  subscription = new Subscription();
  constructor(private dialog: MatDialog) {}

  ngOnInit(): void {
    for (let index = 0; index < this.menus.length; index++) {
      const element = this.menus[index];
      element.paths?.forEach((path: any) => {
        if (path.forms?.filter((form: any) => !form.fid).length > 0) {
          this.unsavedTemplates.push(path);
        }
      });
    }
  }

  setValue() {
    if (this.unsavedTemplates.length > 0) {
      const sharedDialogRef = this.dialog.open(SharedConfirmationDialogComponent, {
        width: '386px',
        data: {
          title: 'Mark as complete?',
          materialIcon: 'info_outline',
          text: `Are you sure you want to mark ${this.menus[0]?.data_type} as complete? There are incomplete items which will not be saved.`,
          proceedTitle: 'Yes',
          backBUttonTitle: 'No',
          darkText: true,
        },
      });

      this.subscription.add(
        sharedDialogRef.afterClosed().subscribe((confirmation) => {
          if (confirmation) {
            this.buttonSlide.showAnimation();
            this.setFinalStepValue.emit();
          }
        })
      );
    } else if (this.emptyTemplate.length) {
      const sharedDialogRef = this.dialog.open(SharedConfirmationDialogComponent, {
        width: '386px',
        data: {
          title: 'Mark as complete?',
          materialIcon: 'info_outline',
          text: `Are you sure you want to mark Financial Accounts as complete? There are institutions with no data.`,
          proceedTitle: 'Yes',
          backBUttonTitle: 'No',
          darkText: true,
        },
      });

      this.subscription.add(
        sharedDialogRef.afterClosed().subscribe((confirmation) => {
          if (confirmation) {
            this.buttonSlide.showAnimation();
            this.setFinalStepValue.emit();
          }
        })
      );
    } else {
      this.buttonSlide.showAnimation();
      this.setFinalStepValue.emit();
    }
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
}
